import * as comlink from 'comlink';
import * as O from 'fp-ts/Option';
import * as A from 'fp-ts/Array';
import * as FileUploadHelper from '@/js/utilities/file_upload_helper';
const generateFromByonicFormat = (data, startRow, aaSeqColumn, siteColumn, glycanColumn, additionalDataColumn) => {
    const truncated = data.slice(startRow);
    const aaSeqList = truncated.map(line => aaSeqColumn < line.length ? line[aaSeqColumn].toString() : '');
    const ucAaSeqList = aaSeqList.map(aaSeq => aaSeq.toUpperCase());
    const siteList = siteColumn < 0
        ? truncated.map(line => {
            const charList = aaSeqColumn < line.length ? [...String(line[aaSeqColumn])] : [];
            const idxOpt = A.findIndex((x) => x === x.toLowerCase())(charList);
            return charList.length === 0
                ? ''
                : O.getOrElse(() => '?')(O.map((n) => (n + 1).toString())(idxOpt));
        })
        : truncated.map(line => siteColumn < line.length ? line[siteColumn].toString() : '');
    const glycanList = truncated.map(line => glycanColumn < line.length ? line[glycanColumn].toString() : '');
    const additionalDataListOpt = additionalDataColumn >= 0
        ? O.some(truncated.map(line => additionalDataColumn < line.length
            ? line[additionalDataColumn].toString()
            : ''))
        : O.none;
    return FileUploadHelper.printTsv(FileUploadHelper.convertColumnsToRows([ucAaSeqList, siteList, glycanList], O.isSome(additionalDataListOpt) ? [additionalDataListOpt.value] : []));
};
const generateFromMSViewerFormat = (_data, _startRow, _aaSeqColumn, _modificationColumn, _additionalDataColumn) => 
// TBD
'';
comlink.expose({
    async getWorksheetNames(buffer) {
        return FileUploadHelper.getWorksheetNames(buffer);
    },
    async getMaxRow(content, sheetName) {
        return FileUploadHelper.getMaxRow(content, sheetName);
    },
    async getMaxColumn(content, sheetName) {
        return FileUploadHelper.getMaxColumn(content, sheetName);
    },
    async generateContent(content, fileFormat, sheetName, startRow, aaSeqColumn, siteColumn, glycanColumn, modificationColumn, additionalDataColumn) {
        const tsv = FileUploadHelper.extractTsv(content, sheetName);
        const data = FileUploadHelper.parseTsv(tsv);
        if (fileFormat === 'byonic') {
            return generateFromByonicFormat(data, startRow, aaSeqColumn, siteColumn, glycanColumn, additionalDataColumn);
        }
        // fileFormat === 'msviewer'
        return generateFromMSViewerFormat(data, startRow, aaSeqColumn, modificationColumn, additionalDataColumn);
    },
});
